import g from "./ghl-ui.es1169.js";
import { createTheme as u } from "./ghl-ui.es855.js";
import x from "./ghl-ui.es1157.js";
import T from "./ghl-ui.es1029.js";
import b from "./ghl-ui.es903.js";
import f from "./ghl-ui.es1119.js";
import D from "./ghl-ui.es1164.js";
import { changeColor as v } from "./ghl-ui.es904.js";
const S = (m) => {
  const {
    hoverColor: r,
    fontSize: e,
    textColor2: t,
    textColorDisabled: d,
    popoverColor: l,
    primaryColor: i,
    borderRadiusSmall: c,
    iconColor: a,
    iconColorDisabled: C,
    textColor1: s,
    dividerColor: o,
    boxShadow2: p,
    borderRadius: n,
    fontWeightStrong: h
  } = m;
  return Object.assign(Object.assign({}, g), {
    itemFontSize: e,
    calendarDaysFontSize: e,
    calendarTitleFontSize: e,
    itemTextColor: t,
    itemTextColorDisabled: d,
    itemTextColorActive: l,
    itemTextColorCurrent: i,
    itemColorIncluded: v(i, {
      alpha: 0.1
    }),
    itemColorHover: r,
    itemColorDisabled: r,
    itemColorActive: i,
    itemBorderRadius: c,
    panelColor: l,
    panelTextColor: t,
    arrowColor: a,
    calendarTitleTextColor: s,
    calendarTitleColorHover: r,
    calendarDaysTextColor: t,
    panelHeaderDividerColor: o,
    calendarDaysDividerColor: o,
    calendarDividerColor: o,
    panelActionDividerColor: o,
    panelBoxShadow: p,
    panelBorderRadius: n,
    calendarTitleFontWeight: h,
    scrollItemBorderRadius: n,
    iconColor: a,
    iconColorDisabled: C
  });
}, L = u({
  name: "DatePicker",
  common: x,
  peers: {
    Input: T,
    Button: b,
    TimePicker: f,
    Scrollbar: D
  },
  self: S
}), A = L;
export {
  A as default,
  S as self
};
